module.exports = __webpack_public_path__ + "media/barcode.0601a26f.mp3";